import React, { PureComponent } from 'react';
import size from 'lodash/size';
import get from 'lodash/get';
import PropTypes from 'prop-types';

import styles from './styles';

export class Article extends PureComponent {
  render() {
    const { article } = this.props;

    if (!size(article)) return null;

    return (
      <div style={styles.articleContainer} className="kb-article">
        <h3>{get(article, 'title')}</h3>
        <div
          key="border"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: get(article, 'htmlBody'),
          }}
        />
      </div>
    );
  }
}

Article.propTypes = {
  article: PropTypes.instanceOf(Object),
};

Article.defaultProps = {
  article: {},
};

export default Article;
